import { render, staticRenderFns } from "./contentsRepeat.component.vue?vue&type=template&id=6bc0399a&scoped=true&"
import script from "./contentsRepeat.component.vue?vue&type=script&lang=js&"
export * from "./contentsRepeat.component.vue?vue&type=script&lang=js&"
import style0 from "./contentsRepeat.component.vue?vue&type=style&index=0&id=6bc0399a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0399a",
  null
  
)

export default component.exports